import React from 'react';
import styled from "styled-components";
import { Helmet } from "react-helmet";

const Wrap = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    div {
        font-size: 10rem;
    }
    h2 {
        display: block;
        margin-bottom: 30px;
    }
    a {
        cursor: pointer;
        &:hover {
            color: tomato;
        }
    }
`;

const PageNotFound = () => {
    return (
        <>
            <Helmet>
                <title>바른정플란트치과 :: 존재하지 않는 페이지</title>
                <meta name="description" content="존재하지 않는 페이지" />
                <meta property="og:description" content="페이지가 존재하지 않습니다." />
            </Helmet>
            <Wrap>
                <div>😰</div>
                <h2>페이지가 존재하지 않습니다.</h2>
                <a href="/">바른정플란트치과 메인페이지 바로가기</a>
            </Wrap>
        </>
    );
};

export default PageNotFound;